import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isUpdatedOrder: false
}

export const orderListSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    updateOrderList: (state) => {
      state.isUpdatedOrder = !state.isUpdatedOrder
    }
  }
})

export const orderListReducer = orderListSlice.reducer

export const orderListActions = orderListSlice.actions
